/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum BulkDeleteVisitsErrorReason {
  VISIT_IS_SCHEDULED="VISIT_IS_SCHEDULED",
VISIT_IS_SCHEDULING="VISIT_IS_SCHEDULING",
VISIT_IS_LOCKED="VISIT_IS_LOCKED",
VISIT_IS_COMPLETED="VISIT_IS_COMPLETED",
VISIT_IS_ALREADY_DELETED="VISIT_IS_ALREADY_DELETED",
UNKNOWN_REASON="UNKNOWN_REASON"
}

/**
* BulkDeleteVisitsErrorReason
*/
export const BulkDeleteVisitsErrorReasonEnumType = types.enumeration("BulkDeleteVisitsErrorReason", [
        "VISIT_IS_SCHEDULED",
  "VISIT_IS_SCHEDULING",
  "VISIT_IS_LOCKED",
  "VISIT_IS_COMPLETED",
  "VISIT_IS_ALREADY_DELETED",
  "UNKNOWN_REASON",
      ])
